const userLocale = navigator.language;

export const formatNumber = (
  formatOptions: object,
  number: number,
  locale: string = userLocale
) => new Intl.NumberFormat(locale, formatOptions).format(number);

export const formatDate = (
  formatOptions: object,
  date: Date,
  locale: string = userLocale
) => new Intl.DateTimeFormat(locale, formatOptions).format(date);
